import { useSyncExternalStore } from "react";
import type { OperationStore } from "./operationStore";

export function useOperations(store: OperationStore) {
  return useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);
}
